@custom-media --mobile (max-width: 768px);

.formItem {
  margin: 1em 0;

  & input.error {
    box-shadow: 0 0 1em var(--red);
  }

  &>h2 {
    margin-top: 3rem;
  }
}

.contentContainer {
  display: flex;

  @media (--mobile) {
    flex-direction: column;
  }
}

.contentColumn {
  flex-grow: 1;
  min-width: 50%;
  padding-right: 1em;

  &:last-child {
    padding: 0;
  }

  &.sideBar {
    min-width: 33%;
  }

  &.mainContent {
    flex-grow: 2;
    min-width: 66%;
  }
}

.columnTitle {
  font-size: 1.2em;
  font-weight: bold;
  text-transform: none;
}

.errorContainer {
  display: none;
  color: var(--red);
  margin-bottom: 0.5em;

  p {
    margin-bottom: 0;
  }
}

.errorContainer.error {
  display: block;
}

.flexContainer {
  display: flex;
  justify-content: flex-end;

  &>div {
    flex: 1;
    margin-right: 1em;
  }

  &>div:last-child {
    margin-right: 0;
  }
}

.navigation {
  display: flex;
  justify-content: flex-end;
  margin-top: 5em;

  &>a {
    margin-left: 1em;
  }

  &>button {
    margin-left: 1em;
  }

  & .disabled {
    pointer-events: none;
    background-color: var(--darkSilver);
  }
}

.itemActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5em;
  white-space: nowrap;
  align-items: center;

  & .remove {
    color: var(--black);
    margin: 0;
    padding: 0.5em 1em;
    border: 0;
    background: transparent;
  }
}

.headerInput,
.bottomInput {
  display: flex;
  margin-left: 1em;
  margin-right: 1em;
  align-items: center;

  & .checkbox {
    font-size: 1.125em;
    font-weight: 300;
    line-height: 2.4;
    margin: 0;
  }

  & .textInput {
    margin-right: 0.5em;
  }

  & .dropdown {
    min-width: 10em;
  }
}

.dimensionSelect {
  min-width: 14em;
  background-position: 95% 60%;
}

.actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 1em;
  margin-right: 1em;
}

.infoItem {
  margin-bottom: 1.5em;
}

.validationErrorsContainer {
  color: var(--red);
}

h2.subSection {
  margin-top: 2rem;
}

.row:nth-child(odd) {
  background-color: var(--silver);
}
